import { globalActionTypes } from "./actionTypes";

export const switchView = (viewName: string) => ({
	type: globalActionTypes.SWITCH_VIEW,
	payload: { viewName }
});

export const setStep = (step: number) => ({
	type: globalActionTypes.SET_STEP,
	payload: { step }
});

export const moveNext = () => ({
	type: globalActionTypes.NEXT_STEP,
	payload: {}
});

export const movePrev = () => ({
	type: globalActionTypes.PREV_STEP,
	payload: {}
});

export const activateLoader = () => ({
	type: globalActionTypes.SET_LOADER_ACTIVE,
	payload: {}
});

export const deactivateLoader = () => ({
	type: globalActionTypes.SET_LOADER_INACTIVE,
	payload: {}
});
